import { ProcessingRuleItem, useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { SnackbarState } from '@/modules/core/core.types';
import { useSnackbar } from '@/modules/core/hooks';
import { QUERY_KEY } from '@/modules/ProcessingDefinition/ProcessingRule/queries/useProcessingRules.query';
import { useProcessingRulesParamsStore } from '@/modules/ProcessingDefinition/ProcessingRule/stores';

interface TierPayload {
  name: string;
  payout_definition_id: string;
  tier_trigger_ids: number[];
  is_send_trigger_notification?: boolean;
  display_name?: string;
  plan_id?: string;
  is_lock_purse?: boolean;
  plan_ids_for_card_purse_lock?: number[];
}
interface ProcessingRulePayloadBody {
  name: string;
  organization_id?: string;
  processing_rule_type?: string;
  tiers: TierPayload[];
}
const useCreateProcessingRuleQuery = (
  updatedElement?: ProcessingRuleItem,
  onSuccess?: (ruleId: string, ruleName: string) => void
) => {
  const { handleAddPermanentSnackbar } = useSnackbar();
  const setNewId = useProcessingRulesParamsStore((state) => state.setNewItemId);
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading } = useMutation(
    (payload: ProcessingRulePayloadBody) =>
      updatedElement
        ? api.put(API_URL.PROCESSING_RULES_BY_ID(updatedElement?.id), payload)
        : api.post(API_URL.PROCESSING_RULES, payload),
    {
      onSuccess: (data) => {
        const ruleId = `${data.data.id || ''}`;
        const ruleName = data?.data?.name || '';
        setNewId(ruleId);
        handleAddPermanentSnackbar({
          text: updatedElement ? 'Processing rule was updated' : 'Processing rule was created',
          closeIcon: true,
          state: SnackbarState.positive,
        });
        queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });

        if (onSuccess) {
          onSuccess(ruleId, ruleName);
        }
      },
    }
  );

  return { mutateAsync, isLoading };
};

export default useCreateProcessingRuleQuery;
